(function ($) {
  var page = 0;
  var count = 0;

  $.fn.initBlog = function (options) {
    var settings = $.extend({
      blog: "Notizie",
      btn: "#loadMore",
      container: "#blog-content",
      limit: 6,
      articleTemplate: '<div class="single-content brand isotope-item col-sm-6 col-md-4 ${tags}">' +
      '<div class="rte">' +
      '<p>' +
      '<a href="${url}">' +
      '<img src="${image.originalSrc}">' +
      '</a>' +
      '</p>' +
      '</div>' +
      '<div class="date">${publishedAt} ${tags}</div> ' +
      '<h2><a href="${url}">${title}</a></h2>' +
      '<p class="action-link">' +
      '<a href="${url}">Discover more</a>' +
      '</p>' +
      '</div>',
      afterRender: null
    }, options);


    //Load first bunch of articles
    loadMore(settings);

    //Attach action to loadMore btn
    $(settings.btn).click(function () {
      return loadMore(settings);
    })

    return this;

  };

  //TODO: add pagination on Graphql call
  function loadMore(settings) {
    var articles = null;
    if (!articles) {
      $.ajax({
        // url: "https://76e5b7850e9e32271c81d358c82bb2fb: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@loriblu-com.myshopify.com/admin/api/2021-07/blogs/" + settings.blog + "/articles.json",
        url: 'https://loriblu-com.myshopify.com/api/2022-10/graphql.json',
        headers: {
          "X-Shopify-Storefront-Access-Token": "69f8d3f9eaa5ef2608e3869e97de5ef3",
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          query: `{
                         blogs(first: 1 query: "title:'${settings.blog}'"){
                            edges{
                              node{
                                id title
                                articles(first:250,sortKey:PUBLISHED_AT, reverse:true){
                                  edges{
                                    node{
                                      id contentHtml excerptHtml excerpt handle publishedAt tags title handle
                                      image{altText height id originalSrc transformedSrc width}
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }`
        }),
        type: 'POST',
        dataType: 'json'
      }).done(function (data) {
        articles = data.data.blogs.edges[0].node.articles.edges;
        sliceAndShow(articles, settings);
      });
    } else {
      sliceAndShow(articles, settings);
    }
  }

  function addFormat(articles) {
    var a = [];
    for (let article of articles) {
      article = article.node;
      // format date
      var date = article.publishedAt.substr(0, 10);
      var nodes = date.split('-');
      article.publishedAt = nodes[2] + '/' + nodes[1] + '/' + nodes[0];

      article.url = window.location.href + '/' + article.handle;
      a.push(article);
    }
    return a;
  }

  function sliceAndShow(articles, settings) {
    if (!articles.length) {
      return;
    }

    //dates format
    var showing = addFormat(articles);
    count += showing.length;
    //apply template with jquery tmpl plugin
    var renderedArticles = $.tmpl(settings.articleTemplate, showing);
    //setup masonry
    var container = $(settings.container);
    container.height(container.height + 500);
    container.masonry()
      .append(renderedArticles)
      .masonry('appended', renderedArticles)
      .masonry();
    window.setTimeout(function () {
      $(settings.container).masonry({
        itemSelector: '.isotope-item',
      });
    }, 300)
    //hide load more btn if finished
    if (count >= articles.length) {
      $(settings.btn).hide();
    }
    //optional after render actions
    if (settings.afterRender) {
      settings.afterRender();
    }
    page++;
  }
}(jQuery));